import React from "react";
import GlobalStyles from "./styles/GlobalStyles";
import Home from "./components/Home";

function App() {
  return (
    <>
      <GlobalStyles />
      <Home />
    </>
  );
}

export default App;
